import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import moment from "moment";
import $ from "jquery";
import { LocalizationProvider, DateTimePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { minDate } from "../../Constants/Constants";
const UpdateTripDetails = ({
  selectedRowsData,
  updateHandleChange,
  getData,
  setSelectedRowsData,
  handleDateChange,
}) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [company, setCompany] = useState([]);
  const [selectedVehicleId, setSelectedVehicleId] = useState("");
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [selectedStafflId, setSelectedStaffId] = useState("");
  const [vehicle, setVehicle] = useState([]);
  const [Staff, setStaff] = useState([]);
  const closeModal = () => {
    $(".custon-close-button-color").trigger("click");
  };

  function resetFileds() {
    setSelectedRowsData({
      start_reading: "",
      location_reading: "",
      return_reading: "",
      start_date: "",
      departure_datetime: null,
      end_date: "",
      return_datetime: null,
      return_location: "",
      trip_status: "",
      driver_name: "",
      advance_pay: 0,
      unloading_charges: 0,
      da_amount: 0,
      toll_tax: 0,
      grease: 0,
      air_puncture: 0,
      miscellaneous: 0,
      remarks: "",
      refuel_place: "",
      reading_refuel_place: 0,
      diesel_ltr: 0,
      running: 0,
      rate: 0,
    });
    setSelectedVehicleId("");
    setSelectedCompanyId("");
    setSelectedRowsData("");
  }

  const handleUpdateData = async (e) => {
    e.preventDefault();
    const {
      id,
      start_reading,
      location_reading,
      return_reading,
      start_date,
      departure_datetime,
      end_date,
      return_datetime,
      return_location,
      trip_status,
      driver_name,
      advance_pay,
      unloading_charges,
      da_amount,
      toll_tax,
      grease,
      air_puncture,
      miscellaneous,
      remarks,
      refuel_place,
      reading_refuel_place,
      diesel_ltr,
      running,
      rate,
    } = selectedRowsData;
    let BASE_URL = SERVER_URL + `/api/trips/trips/${user_id}`;

    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        company_id: selectedCompanyId,
        vehicle_id: selectedVehicleId,
        start_reading,
        location_reading,
        return_reading,
        start_date: start_date ? moment(start_date).format("YYYY-MM-DD") : null,
        departure_datetime,
        end_date: end_date ? moment(end_date).format("YYYY-MM-DD") : null,
        return_datetime,
        return_location,
        trip_status,
        driver_name,
        advance_pay,
        unloading_charges,
        da_amount,
        toll_tax,
        grease,
        air_puncture,
        miscellaneous,
        remarks,
        refuel_place,
        reading_refuel_place,
        diesel_ltr,
        running,
        rate,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      closeModal();
      resetFileds();
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    setCompany(result.data);
  };

  useEffect(() => {
    getCompany();
  }, []);

  useEffect(() => {
    if (selectedRowsData) {
      setSelectedCompanyId(selectedRowsData?.company_id);
      setSelectedStaffId(selectedRowsData?.driver_id);
      setSelectedVehicleId(selectedRowsData?.vehicle_id);
    }
  }, [selectedRowsData]);

  const handleVehicleChange = (e) => {
    setSelectedVehicleId(e.target.value);
  };

  const handleStaffChange = (e) => {
    setSelectedStaffId(e.target.value);
  };

  const handleCompanyChange = (e) => {
    const value = e.target.value;
    setSelectedCompanyId(value ? value : "");
    setStaff("");
  };

  // const getStaff = async (e) => {
  //   const BASE_URL =
  //     SERVER_URL +
  //     `/api/staff-detials/drop-staffDetails/${user_id}?company_id=${selectedCompanyId}`;
  //   const res = await fetch(BASE_URL, {
  //     method: "GET",
  //     headers: {
  //       authorization: `Bearer ${token}`,
  //       "Content-Type": "application/json",
  //     },
  //   });
  //   const result = await res.json();
  //   if (res.ok) {
  //     setStaff(result.data);
  //   } else {
  //     setStaff([]);
  //   }
  // };
  // useEffect(() => {
  //   if (selectedCompanyId) {
  //     getStaff();
  //   }
  // }, [selectedCompanyId]);

  const getVehicle = async () => {
    let BASE_URL =
      SERVER_URL + `/api/vehicle-details/all-vehicle-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setVehicle(result.data);
  };

  useEffect(() => {
    getVehicle();
  }, []);
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="editModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Update Trip Details
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFileds}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Add Party Name</h4> */}
                    <form className="form-sample" onSubmit={handleUpdateData}>
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="company_name">
                              Start Point/Location
                            </label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleCompanyChange}
                              value={selectedCompanyId}
                              id="company_name"
                              required
                            >
                              <option value="">Select Company Name</option>
                              {company &&
                                company?.length > 0 &&
                                company?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.company_name}, ${item.location}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        {/* <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="staff_id">Driver Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleStaffChange}
                              value={selectedStafflId}
                              id="staff_id"
                              required
                            >
                              <option value="">Select Driver Name</option>
                              {Staff &&
                                Staff?.length > 0 &&
                                Staff?.map((item, index) => {
                                  return (
                                    <React.Fragment key={index}>
                                      <option
                                        value={item.id}
                                      >{`${item.staff_name}`}</option>
                                    </React.Fragment>
                                  );
                                })}
                            </select>
                          </div>
                        </div> */}
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="material_name">
                              Vehicle Number
                            </label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleVehicleChange}
                              value={selectedVehicleId}
                              id="material_name"
                              required
                            >
                              <option value="">Select Vehicle</option>
                              {vehicle &&
                                vehicle?.length > 0 &&
                                vehicle?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.vehicle_number}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="return_location">
                              Return Point/Location
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="return_location"
                              id="return_location"
                              placeholder="Return Point/Location"
                              onChange={updateHandleChange}
                              value={selectedRowsData.return_location}
                              autoComplete="off"
                            />
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="battery_num">Start Reading</label>
                            <input
                              type="number"
                              className="form-control"
                              name="start_reading"
                              id="start_reading"
                              placeholder="Start Reading"
                              onChange={updateHandleChange}
                              value={selectedRowsData.start_reading}
                              autoComplete="off"
                              min="0"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="location_reading">
                              Location Reading
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              name="location_reading"
                              id="location_reading"
                              placeholder="Location Reading"
                              onChange={updateHandleChange}
                              value={selectedRowsData.location_reading}
                              autoComplete="off"
                              min="0"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="return_reading">
                              Return Reading
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              name="return_reading"
                              id="return_reading"
                              placeholder="Return Reading"
                              onChange={updateHandleChange}
                              value={selectedRowsData.return_reading}
                              min="0"
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="trip_status">Trip Status</label>
                            <select
                              className="form-control form-control-lg"
                              name="trip_status"
                              id="trip_status"
                              onChange={updateHandleChange}
                              value={selectedRowsData.trip_status}
                              required
                            >
                              <option value="">Select Status</option>
                              <option value="ongoing">On-going</option>
                              <option value="completed">Completed</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="start_date">Start Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="start_date"
                              id="start_date"
                              onChange={updateHandleChange}
                              value={selectedRowsData.start_date}
                              max={new Date().toISOString().split("T")[0]}
                              required
                              min={minDate}
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="Departure Datetime">
                              Departure Date Time
                            </label>
                            {/* <input
                              type="date"
                              className="form-control"
                              name="departure_datetime"
                              id="departure_datetime"
                              placeholder="Departure Datetime"
                              onChange={updateHandleChange}
                              value={selectedRowsData.departure_datetime}
                            /> */}
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                              <DateTimePicker
                                // label={"Select in 24hr Format"}
                                className="form-control date-control"
                                name="departure_datetime"
                                id="departure_datetime"
                                maxDate={moment()}
                                minDate={moment(minDate)}
                                format="YYYY-MM-DD hh:mm:ss A"
                                // ampm={false}
                                timeSteps={{ hours: 1, minutes: 1 }}
                                value={
                                  selectedRowsData.departure_datetime
                                    ? moment(
                                        selectedRowsData.departure_datetime,
                                        "YYYY-MM-DD hh:mm:ss A"
                                      )
                                    : null
                                }
                                onChange={(date) =>
                                  handleDateChange("departure_datetime", date)
                                }
                              />
                            </LocalizationProvider>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="end_date">End Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="end_date"
                              id="end_date"
                              placeholder="End Date"
                              onChange={updateHandleChange}
                              value={selectedRowsData.end_date}
                              autoComplete="off"
                              min={minDate}
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="return_datetime">
                              Return Date Time
                            </label>
                            {/* <input
                              type="date"
                              className="form-control"
                              name="return_datetime"
                              id="return_datetime"
                              placeholder="Return Date Time"
                              onChange={updateHandleChange}
                              value={selectedRowsData.return_datetime}
                            /> */}
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                              <DateTimePicker
                                // label={"Select in 24hr Format"}
                                className="form-control date-control"
                                name="return_datetime"
                                id="return_datetime"
                                format="YYYY-MM-DD hh:mm:ss A"
                                minDate={moment(minDate)}
                                // ampm={false}
                                timeSteps={{ hours: 1, minutes: 1 }}
                                value={
                                  selectedRowsData.return_datetime
                                    ? moment(
                                        selectedRowsData.return_datetime,
                                        "YYYY-MM-DD hh:mm:ss A"
                                      )
                                    : null
                                }
                                onChange={(date) =>
                                  handleDateChange("return_datetime", date)
                                }
                              />
                            </LocalizationProvider>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="driver_name">Driver Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="driver_name"
                              id="driver_name"
                              placeholder="Driver Name"
                              onChange={updateHandleChange}
                              value={selectedRowsData.driver_name}
                              autoComplete="off"
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="advance_pay">Advance Pay</label>
                            <input
                              type="number"
                              className="form-control"
                              name="advance_pay"
                              id="advance_pay"
                              placeholder="Advance Pay"
                              onChange={updateHandleChange}
                              value={selectedRowsData.advance_pay}
                              autoComplete="off"
                              min="0"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="unloading_charges">
                              Unloading Charges
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              name="unloading_charges"
                              id="unloading_charges"
                              placeholder="Unloading Charges"
                              onChange={updateHandleChange}
                              value={selectedRowsData.unloading_charges}
                              autoComplete="off"
                              min="0"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="da_amount">DA Amount</label>
                            <input
                              type="number"
                              className="form-control"
                              name="da_amount"
                              id="da_amount"
                              placeholder="DA Amount"
                              onChange={updateHandleChange}
                              value={selectedRowsData.da_amount}
                              autoComplete="off"
                              min="0"
                            />
                          </div>
                        </div>

                        <div className="col-md-2">
                          <div className="form-group">
                            <label htmlFor="toll_tax">Toll Tax</label>
                            <input
                              type="number"
                              className="form-control"
                              name="toll_tax"
                              id="toll_tax"
                              placeholder="Toll Tax"
                              onChange={updateHandleChange}
                              value={selectedRowsData.toll_tax}
                              autoComplete="off"
                              min="0"
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label htmlFor="grease">Grease</label>
                            <input
                              type="number"
                              className="form-control"
                              name="grease"
                              id="grease"
                              placeholder="Grease"
                              onChange={updateHandleChange}
                              value={selectedRowsData.grease}
                              autoComplete="off"
                              min="0"
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label htmlFor="air_puncture">Air/Puncture</label>
                            <input
                              type="number"
                              className="form-control"
                              name="air_puncture"
                              id="air_puncture"
                              placeholder="Air Puncture"
                              onChange={updateHandleChange}
                              value={selectedRowsData.air_puncture}
                              autoComplete="off"
                              min="0"
                            />
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="miscellaneous">Miscellaneous</label>
                            <input
                              type="number"
                              className="form-control"
                              name="miscellaneous"
                              id="miscellaneous"
                              placeholder="Miscellaneous"
                              onChange={updateHandleChange}
                              value={selectedRowsData.miscellaneous}
                              autoComplete="off"
                              min="0"
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="remarks">Remarks</label>
                            <textarea
                              className="form-control"
                              name="remarks"
                              id="remarks"
                              placeholder="Enter any additional details"
                              rows="4"
                              onChange={updateHandleChange}
                              value={selectedRowsData.remarks}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="refuel_place">Refuel Place</label>
                            <input
                              type="text"
                              className="form-control"
                              name="refuel_place"
                              id="refuel_place"
                              placeholder="Refuel Place"
                              onChange={updateHandleChange}
                              value={selectedRowsData.refuel_place}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="reading_refuel_place">
                              Reading Refuel Place
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              name="reading_refuel_place"
                              id="reading_refuel_place"
                              placeholder="Reading at refuel place"
                              onChange={updateHandleChange}
                              value={selectedRowsData.reading_refuel_place}
                              min="0"
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label htmlFor="diesel_ltr">Diesel (in Ltr.)</label>
                            <input
                              type="number"
                              className="form-control"
                              name="diesel_ltr"
                              id="diesel_ltr"
                              placeholder="Diesel in ltr."
                              onChange={updateHandleChange}
                              value={selectedRowsData.diesel_ltr}
                              min="0"
                              step="0.01" // Allows floating point numbers
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label htmlFor="rate">Rate</label>
                            <input
                              type="number"
                              className="form-control"
                              name="rate"
                              id="rate"
                              placeholder="Rate"
                              onChange={updateHandleChange}
                              value={selectedRowsData.rate}
                              min="0"
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label htmlFor="running">Running (in Km)</label>
                            <input
                              type="number"
                              className="form-control"
                              name="running"
                              id="running"
                              placeholder="Running"
                              onChange={updateHandleChange}
                              value={selectedRowsData.running}
                              min="0"
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateTripDetails;
